import { Toaster as Sonner } from "sonner";
import { useI18n } from "@/i18n/I18nContext";

export function Toaster() {
  const { t } = useI18n();
  return (
    <Sonner
      position="bottom-right"
      closeButton
      containerAriaLabel={t("notifications.label")}
      toastOptions={{
        closeButtonAriaLabel: t("notifications.dismiss"),
        classNames: {
          toast: "!border-border !bg-popover !text-popover-foreground !shadow-lg",
          title: "!font-medium",
          description: "!text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-secondary !text-secondary-foreground",
          closeButton: "!border-border !bg-popover !text-popover-foreground",
          error: "!border-destructive/40",
          success: "!border-success-foreground/30",
          warning: "!border-warning-foreground/30",
        },
      }}
    />
  );
}
